import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { HttpErrorResponse } from '@angular/common/http';

export const CLAIMS_API_ACTIONS = createActionGroup({
  source: 'Claims API',
  events: {
    get: emptyProps(),
    error: props<{ error: HttpErrorResponse }>(),
    success: props<{ data: string[] }>(),
  },
});
